























































import { VTimePicker, VMenu, VTextField, VBtn, VSpacer } from 'vuetify/lib'
import { mdiClock } from '@mdi/js'
import { defineComponent, computed, ref } from '@vue/composition-api'

export default defineComponent({
  inheritAttrs: false,
  name: 'base-input-time-picker',
  components: {
    VTimePicker,
    VMenu,
    VTextField,
    VBtn,
    VSpacer
  },
  props: {
    timeValue: String,
    label: String,
    rules: Array,
    required: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const time = ref(props.timeValue)
    const pickerMenu = ref<any>(null)
    const menuState = ref<boolean>(false)
    const picker = ref<any>(null)
    const activator = ref<any>(null)

    // COMPUTED
    const computedTimeFormatted = computed(() => {
      if (time.value && time.value.length) {
        const [hour, minute] = time.value.split(':')
        let am = true
        let intHour = parseInt(hour)

        if (intHour > 12) {
          intHour -= 12
          am = false
        } else if (intHour === 0) {
          intHour = 12
        } else if (intHour === 12) {
          am = false
        }

        return `${intHour}:${minute} ${am ? 'am' : 'pm'}`
      }
      return ''
    })

    const focusOnPicker = () => {
      menuState.value = true
      setTimeout(() => picker.value.focus(), 100)
    }

    const saveSelection = () => {
      pickerMenu.value.save(time.value)
      setTimeout(() => activator.value.focus(), 100)
    }

    const closePicker = () => {
      menuState.value = false
      setTimeout(() => activator.value.focus(), 100)
    }

    return {
      time,
      pickerMenu,
      menuState,
      mdiClock,
      computedTimeFormatted,
      focusOnPicker,
      saveSelection,
      closePicker,
      picker,
      activator
    }
  }
})
